// src/sectors/pilates/attendance/api/attendanceApi.js
import { http } from 'shared/api/http';

const BASE = '/api/v1/pilates/attendance';

export const attendanceApi = {
  // =========================
  // ✅ NEW FLOW (validate + commit)
  // =========================
  validateMark: (payload) =>
    http(`${BASE}/mark/validate`, {
      method: 'POST',
      body: payload,
      auth: true,
    }),

  commitMark: (payload) =>
    http(`${BASE}/mark/commit`, {
      method: 'POST',
      body: payload,
      auth: true,
    }),

  mark: async (payload) => {
    const dec = await attendanceApi.validateMark(payload);
    if (!dec?.allowed) return dec;
    return attendanceApi.commitMark(payload);
  },

  // =========================
  // ✅ NEW: session participants (modal için)
  // =========================
  getSessionParticipants: (sessionId, last = 5) => {
    const qs = new URLSearchParams();
    qs.set('last', String(last));
    return http(`${BASE}/session/${sessionId}/participants?${qs.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },

  // =========================
  // (Optional) eski CRUD’lar
  // =========================
  create: (payload) => http(`${BASE}`, { method: 'POST', body: payload, auth: true }),
  get: (id) => http(`${BASE}/${id}`, { method: 'GET', auth: true }),
  update: (id, payload) => http(`${BASE}/${id}`, { method: 'PUT', body: payload, auth: true }),
  remove: (id) => http(`${BASE}/${id}`, { method: 'DELETE', auth: true }),

  // =========================
  // ESKİ helper'lar (bunlar varsa kalsın ama artık şart değil)
  // =========================
  listBySession: (sessionId) =>
    http(`${BASE}/by-session/${sessionId}`, { method: 'GET', auth: true }),

  lastByMember: (memberId, limit = 5) => {
    const qs = new URLSearchParams();
    qs.set('limit', String(limit));
    return http(`${BASE}/last-by-member/${memberId}?${qs.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },

  // =========================
  // ✅ NEW: member attendance history
  // =========================
  getMemberAttendanceHistory: (memberId, limit = 50) => {
    const qs = new URLSearchParams();
    qs.set('limit', String(limit));

    return http(`${BASE}/member/${memberId}/history?${qs.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },

  // =========================
  // ✅ NEW: attendance queue (yoklaması girilmemişler)
  // =========================
  attendanceQueue: ({ from, to, trainerId, q, limit = 300 } = {}) => {
    const qs = new URLSearchParams();

    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    if (trainerId != null) qs.set('trainerId', String(trainerId));
    if (q) qs.set('q', q);
    if (limit) qs.set('limit', String(limit));

    return http(`${BASE}/queue?${qs.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },
};
